import React, { useState, useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Skeleton } from "antd";
import Pagination from "rc-pagination";
import LongList from "../components/LongList";
import "rc-pagination/assets/index.css";
import "./styles/scss/AllGame.scss";
import {
	Request,
	catchErrorHandle,
	platformObj,
	indexObj,
	protypeObj,
} from "../common";

export default function App() {
	const location = useLocation();
	const [getPrama] = useSearchParams();

	const ref = useRef();
	const [isWjyz, setIsWjyz] = useState(
		location.state?.from === "wjyz" || getPrama.get("from") === "wjyz"
	);
	const [protype, setProtype] = useState(
		indexObj[location.state?.index] ||
			indexObj[getPrama.get("index")] ||
			"共享游戏"
	); //外部带入index，需要转义
	const [allList, setAllList] = useState(false);
	const [platform, setPlatform] = useState("全部");
	const [tagList, setTagList] = useState([]);
	const [tag, setTag] = useState([]);
	const [page, setPage] = useState(1);
	const [pageSize] = useState(20);
	const [total, setTotal] = useState(0);

	useEffect(() => {
		const req = new Request({
			url: "/api/getProductTag",
			data: {
				page: 1,
				pageSize: 100,
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					setTagList(res.data.data);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, []);

	useEffect(() => {
		let req = null;
		if (isWjyz) {
			req = new Request({
				url: "/open-platform/pro/productInfoSortWjyz",
				source: 1,
				data: {
					protype: protypeObj[protype], //充值卡筛选包含了会员卡密
					sortname: "sale",
					cur: page,
					size: pageSize,
				},
			});

			const getData = async () => {
				try {
					const res = await req.send();

					if (res.code === 200 && res.data?.data) {
						setAllList(res.data.data);
						setTotal(res.data.total);
						ref.current.scrollTo(0, 0);
					}
				} catch (error) {
					console.log(catchErrorHandle(error));
				}
			};

			getData();
		} else {
			let data = {
				page,
				pageSize,
				service: "group",
			};

			platform &&
				platform !== "全部" &&
				(data = {
					...data,
					platform: platformObj[platform],
				});

			tag.length &&
				(data = {
					...data,
					tag_id: tag.join(","),
				});

			req = new Request({
				url: "/api/getProductList",
				data: data,
			});

			const getData = async () => {
				try {
					const res = await req.send();

					if (res.status_code === 1000 && res.data?.data) {
						setAllList(res.data.data);
						setTotal(res.data.total);
						ref.current.scrollTo(0, 0);
					}
				} catch (error) {
					console.log(catchErrorHandle(error));
				}
			};

			getData();
		}

		return () => {
			req.cancel();
		};
	}, [isWjyz, protype, page, pageSize, platform, tag]);

	const defaultConfig = (noPage) => {
		setAllList(false); //处理接口延迟列表显示错误问题
		!noPage && setPage(1);
	};

	const onChange = (current, pageSize) => {
		defaultConfig(true);
		setPage(current);
	};

	return (
		<div className="main">
			<div className="all-game">
				<div className="head">全部游戏</div>

				<div className="body">
					<div className="left" ref={ref}>
						{Array.isArray(allList) ? (
							<LongList from={isWjyz && "wjyz"} list={allList} />
						) : (
							[...new Array(20)].map((ele, index) => {
								return <Skeleton.Avatar key={index} active shape="square" />;
							})
						)}
					</div>
					<div className="right">
						<div className="type">
							<div className="title">
								<div className="left">
									<div></div>商品类型
								</div>
							</div>
							<div className="content">
								{["共享游戏", ...Object.keys(protypeObj)].map((ele, index) => {
									return (
										<div
											key={index}
											onClick={() => {
												if (ele !== protype) {
													defaultConfig();
												}

												if (index === 0) {
													setIsWjyz(false);
												} else {
													setIsWjyz("wjyz");
												}

												setProtype(ele);
											}}
										>
											<button
												type="button"
												className={protype === ele ? "active" : ""}
											></button>
											<span>{ele}</span>
										</div>
									);
								})}
							</div>
						</div>

						{!isWjyz && (
							<>
								<div className="platform">
									<div className="title">
										<div className="left">
											<div></div>平台
										</div>
									</div>
									<div className="content">
										{["全部", ...Object.keys(platformObj).slice(0, 4)].map(
											(ele, index) => {
												return (
													<button
														type="button"
														key={index}
														className={`list-item${
															platform === ele ? " active" : ""
														}`}
														onClick={() => {
															if (ele !== platform) {
																defaultConfig();
															}

															setPlatform(ele);
														}}
													>
														{ele}
													</button>
												);
											}
										)}
									</div>
								</div>

								<div className="tag">
									<div className="title">
										<div className="left">
											<div></div>标签
										</div>
									</div>
									<div className="content">
										{tagList.map((ele, index) => {
											return (
												<button
													type="button"
													key={index}
													className={`list-item${
														tag.includes(ele.tag_id) ? " active" : ""
													}`}
													onClick={() => {
														defaultConfig();

														setTag((c) => {
															let arr = [...c];

															if (arr.includes(ele.tag_id)) {
																const index = arr.findIndex(
																	(id) => id === ele.tag_id
																);

																arr.splice(index, 1);
															} else {
																arr = [...c, ele.tag_id];
															}

															return arr;
														});
													}}
													title={ele.tag_name}
												>
													{ele.tag_name}
												</button>
											);
										})}
									</div>
								</div>
							</>
						)}
					</div>
				</div>
				{!!allList.length && (
					<Pagination
						showQuickJumper
						current={page}
						onChange={onChange}
						pageSize={pageSize}
						total={total}
						prevIcon="<"
						nextIcon=">"
					/>
				)}
			</div>
		</div>
	);
}
